import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=e54b0206&scoped=true&"
import script from "./Guardian.vue?vue&type=script&lang=js&"
export * from "./Guardian.vue?vue&type=script&lang=js&"
import style0 from "./Guardian.vue?vue&type=style&index=0&id=e54b0206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54b0206",
  null
  
)

export default component.exports